import type {FunctionComponent, SyntheticEvent} from 'react'
import React from 'react'
import clsx from 'clsx'
import type {AffiliateLink, BuyingOption} from '~/types'
import BuyingOptionCard from './buying-options-card'

interface BuyingOptionsProps extends React.HTMLAttributes<HTMLDivElement> {
  buyingOptions: BuyingOption[]
  productName: string
  type: 'main-cta' | 'options-cta'
  handleCardClick: (
    _e: SyntheticEvent,
    index: number,
    affiliateLink: AffiliateLink,
    affiliateLinkWithClickId: string,
    itemName: string,
    redirectUrl: string,
    elementName: string,
    elementPlace: string,
  ) => void
  shouldForceTrackAnalytics: boolean
  trackSearchParams: string
  clickId: string
}
const BuyingOptions: FunctionComponent<BuyingOptionsProps> = ({
  buyingOptions,
  productName,
  type,
  handleCardClick,
  shouldForceTrackAnalytics,
  trackSearchParams,
  clickId,
  ...attributes
}: BuyingOptionsProps) => {
  return (
    <div className={clsx('relative mt-4', type === 'main-cta' && 'tablet:mt-0')}>
      <div {...attributes}>
        {buyingOptions?.map((option, index) => {
          return (
            <BuyingOptionCard
              key={`${option.id}-${option.link}-${index}-${type}`}
              buyingOption={option}
              index={index}
              productName={productName}
              type={type}
              handleCardClick={handleCardClick}
              shouldForceTrackAnalytics={shouldForceTrackAnalytics}
              trackSearchParams={trackSearchParams}
              clickId={clickId}
            />
          )
        })}
      </div>
    </div>
  )
}

export default BuyingOptions
